/* eslint-disable no-redeclare, @typescript-eslint/no-explicit-any */
import { lazy } from 'react';
function lazyWithPreload(input) {
    const factory = () => (typeof input === 'string' ? import(input) : input());
    return [lazy(factory), factory];
}
export default lazyWithPreload;
